// extracted by mini-css-extract-plugin
module.exports = {"questionContainer":"PublicService_questionContainer__l908A"};